import React, { useEffect, useState } from "react";
import { fmtRate } from "../pages/public/api";

const DIGITS = "0123456789".split("");

/* Slot-machine digits while a live rate loads; settles onto the real number when it lands. */
export function SlotRate({ rate, loading, star = false, className = "" }) {
  const [settled, setSettled] = useState(false);
  useEffect(() => {
    if (!loading && rate != null) { setSettled(true); const t = setTimeout(() => setSettled(false), 500); return () => clearTimeout(t); }
  }, [loading, rate]);
  if (loading && rate == null) {
    return (
      <span className={`slot ${className}`} aria-label="Loading today's rate" aria-busy="true" data-testid="rate-slot-spinner">
        <SlotCol speed={0.55} /><span className="slot-dot">.</span><SlotCol speed={0.7} /><SlotCol speed={0.85} /><span className="slot-pct">%</span>
      </span>
    );
  }
  return <span className={`slot-val ${settled ? "settled" : ""} ${className}`}>{fmtRate(rate)}{star && rate != null && <sup>*</sup>}</span>;
}

function SlotCol({ speed }) {
  return (
    <span className="slot-col">
      <span className="slot-strip" style={{ animationDuration: `${speed}s` }}>{[...DIGITS, ...DIGITS].map((d, i) => <span key={i}>{d}</span>)}</span>
    </span>
  );
}
